module.exports = __webpack_public_path__ + "static/media/0223_IMG_LE_PLAFOND_RAL_9010.5d666858.png";